import { watchSignOut, watchStartSignIn } from './login';

export const loginSagas = [
  watchStartSignIn,
  watchSignOut,
];
